<template>
  <v-container fluid>
    <v-layout>
      <v-flex xs7 md8>
        <el-card class="box-card mb-3">
          <h3 class="title font-weight-black mb-3">Create new product</h3>
          <v-divider></v-divider>
          <div class="mt-3">
            <el-form :label-position="`top`" size="medium" label-width="140px" class>
              <el-form-item label="Store">
                <el-col :span="24">
                  <el-select
                    style="width:100%;"
                    v-model="form.store_id"
                    placeholder="Select Store"
                    @change="onSelectStore(form.store_id)"
                  >
                    <el-option
                      v-for="item in storeList"
                      :key="item.store_id"
                      :label="item.supplier_info.supplier_name+` - `+item.store_info.find(x=>x.lang=='th').store_name"
                      :value="item.store_id"
                    ></el-option>
                  </el-select>
                </el-col>
              </el-form-item>
              <el-form-item label="Product Name">
                <el-col :span="24">
                  <el-input placeholder="eg : คูปองส่วนลด"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="Product Short Name">
                <el-col :span="24">
                  <el-input placeholder="eg : คูปองส่วนลด"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="Product Excerpt">
                <el-col :span="24">
                  <el-input type="textarea" placeholder="eg : คำนำสินค้า"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="Product Detail">
                <el-col :span="24">
                  <el-input type="textarea" rows="5" placeholder="eg : คำอธิบายสินค้า"></el-input>
                </el-col>
              </el-form-item>
              <v-layout>
                <v-flex xs12 md6 class="pr-2">
                  <el-form-item label="Unit Price">
                    <el-col :span="24">
                      <el-input type="number" placeholder="eg : 1000"></el-input>
                    </el-col>
                  </el-form-item>
                </v-flex>
                <v-flex xs12 md6>
                  <el-form-item label="Sale Price">
                    <el-col :span="24">
                      <el-input type="number" placeholder="eg : 800"></el-input>
                    </el-col>
                  </el-form-item>
                </v-flex>
              </v-layout>
              <el-form-item label="Status">
                <el-radio v-model="form.product_status" label="published">Published</el-radio>
                <el-radio v-model="form.product_status" label="inactive">Inactive</el-radio>
              </el-form-item>
            </el-form>
          </div>
        </el-card>
        <el-card class="box-card mb-3">
          <h3 class="title font-weight-black mb-3">Inventory</h3>
          <v-divider></v-divider>
          <el-form :label-position="`top`" size="medium" label-width="140px" class>
            <v-layout>
              <v-flex xs12 md6 class="pr-2">
                <el-form-item label="In Stock">
                  <el-col :span="24">
                    <el-input type="number" v-model="form.unit_in_stock" placeholder="eg : 1000"></el-input>
                  </el-col>
                </el-form-item>
              </v-flex>
              <v-flex xs12 md6>
                <el-form-item label="Quantity per Unit">
                  <el-col :span="24">
                    <el-input type="number" v-model="form.quantity_per_unit" placeholder="eg : 1"></el-input>
                  </el-col>
                </el-form-item>
              </v-flex>
            </v-layout>
          </el-form>
        </el-card>
        <el-card class="box-card mb-3">
          <h3 class="title font-weight-black mb-3">Quota</h3>
          <v-divider></v-divider>
          <el-form :label-position="`top`" size="medium" label-width="140px" class>
            <v-layout>
              <v-flex xs12 md6 class="pr-2">
                <el-form-item label="Quota per order">
                  <el-col :span="24">
                    <el-input v-model="condition.quota_per_order" type="number" placeholder></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="Quota per user">
                  <el-col :span="24">
                    <el-input v-model="condition.quota_per_user" type="number" placeholder></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="Quota per day">
                  <el-col :span="24">
                    <el-input v-model="condition.quota_per_day" type="number" placeholder></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="Quota per channel">
                  <el-col :span="24">
                    <el-input v-model="condition.quota_per_channel" type="number" placeholder></el-input>
                  </el-col>
                </el-form-item>
              </v-flex>
            </v-layout>
          </el-form>
        </el-card>
        <el-card class="box-card mb-3">
          <h3 class="title font-weight-black mb-3">Coupon Condition</h3>
          <v-divider></v-divider>
          <div style="margin-top: 20px">
            <el-form :label-position="`top`" size="medium" label-width="140px" class>
              <el-form-item label>
                <el-col :span="24">
                  <el-checkbox v-model="form.condition">Enable Coupon Condition</el-checkbox>
                </el-col>
              </el-form-item>
              <template v-if="condition">
                <el-form-item label="Period">
                  <el-col :span="24">
                    <el-date-picker
                      v-model="condition.period"
                      size="mini"
                      type="daterange"
                      format="dd-MMM-yyyy"
                      range-separator="To"
                      start-placeholder="Start date"
                      end-placeholder="End date"
                    ></el-date-picker>
                  </el-col>
                </el-form-item>
                <el-form-item label="Available on day">
                  <el-col :span="24">
                    <el-checkbox-group v-model="condition.days" size="mini">
                      <el-checkbox-button v-for="day in days" :label="day" :key="day">{{day}}</el-checkbox-button>
                    </el-checkbox-group>
                  </el-col>
                </el-form-item>
                <el-form-item label="Available time each day">
                  <el-col :span="24">
                    <div v-for="(item, index) in days" v-bind:key="item">
                      <span style="display:inline-block; width:50px;">{{item}}</span>
                      <el-time-picker
                        is-range
                        :disabled="!condition.days.includes(item)"
                        arrow-control
                        size="mini"
                        format="HH:mm"
                        v-model="condition.times[index].range"
                        range-separator="To"
                        start-placeholder="Start time"
                        end-placeholder="End time"
                      ></el-time-picker>
                    </div>
                  </el-col>
                </el-form-item>
              </template>
            </el-form>
          </div>
        </el-card>
      </v-flex>
      <v-flex xs5 md4 class="pl-3">
        <div class="sticky">
          <el-card class="box-card">
            <h3 class="title font-weight-black mb-3">Summary</h3>
            <v-divider></v-divider>
            <div class="mt-3">
              <pre>
                    {{condition}}
               </pre>
            </div>
            <div class="mt-3">
              <el-button
                type="primary"
                style="width:100%;"
                @click="onCreateProduct()"
              >Create Product</el-button>
            </div>
          </el-card>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import Service from "../../../services";
import { monthList } from "../../../utils/Constants";

export default {
  name: "create-poi-dialog",
  props: {
    dialog: { default: false },
    shopId: { default: null }
  },
  data() {
    return {
      days: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      storeList: [],
      form: {
        product_slug: "",
        product_sku: "",
        product_status: "inactive",
        store_id: null,
        unit_in_stock: "100",
        unit_on_order: "0",
        quantity_per_unit: 1,
        condition: true
      },
      condition: {
        period: [],
        days: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        times: [
          {
            day: "Mon",
            range: [
              new Date(2016, 9, 10, 0, 0),
              new Date(2016, 9, 10, 23, 59, 59)
            ]
          },
          {
            day: "Tue",
            range: [
              new Date(2016, 9, 10, 0, 0),
              new Date(2016, 9, 10, 23, 59, 59)
            ]
          },
          {
            day: "Wed",
            range: [
              new Date(2016, 9, 10, 0, 0),
              new Date(2016, 9, 10, 23, 59, 59)
            ]
          },
          {
            day: "Thu",
            range: [
              new Date(2016, 9, 10, 0, 0),
              new Date(2016, 9, 10, 23, 59, 59)
            ]
          },
          {
            day: "Fri",
            range: [
              new Date(2016, 9, 10, 0, 0),
              new Date(2016, 9, 10, 23, 59, 59)
            ]
          },
          {
            day: "Sat",
            range: [
              new Date(2016, 9, 10, 0, 0),
              new Date(2016, 9, 10, 23, 59, 59)
            ]
          },
          {
            day: "Sun",
            range: [
              new Date(2016, 9, 10, 0, 0),
              new Date(2016, 9, 10, 23, 59, 59)
            ]
          }
        ],
        quota_per_order: 0,
        quota_per_user: 0,
        quota_per_day: 0,
        quota_per_channel: 0
      }
    };
  },
  created() {
    Service.CommerceStore.gets().then(res => {
      this.storeList = res.data;
    });
  },
  methods: {
    onSelectStore(store_id) {},
    onCreateProduct() {}
  }
};
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 4px;
}
</style>